// extracted by mini-css-extract-plugin
export default {"status":"SeriesStatusCell-status-DVtgu TableRowCell-cell-giPrj","statusIcon":"SeriesStatusCell-statusIcon-thKGE"};